"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextTitle2 = void 0;
var _createText = require("./createText");
const TextTitle2 = (0, _createText.createText)('title2');
exports.TextTitle2 = TextTitle2;